<script>
    import {onMount} from "svelte";
    import Field from './Field.svelte';
    import {uuid} from '../Database.svelte';

    export let id = uuid();

    export let fields = [];
    export let data = {};
    export let errors = {};

    export let saveButton = "Save Changes";
    export let cancelButton = "Cancel";

    export let showDelete = false;

    export let title = "";

    export let width = undefined;

    export let cancelAction = () => {};
    export let saveAction = () => {};
    export let deleteAction = () => {};

    let el;

    onMount(() => {
        el.elements[0].focus();
    })
</script>

<div class="modal is-active">
    <div class="modal-background"></div>
    <div class="modal-card" style="{width ? `width: ${width}px`: ""}">
    <form on:submit|preventDefault={() => saveAction(data)} bind:this={el}>
        <header class="modal-card-head">
            <p class="modal-card-title">{title}</p>
            <span class="delete" aria-label="close" on:click|preventDefault={cancelAction}></span>
        </header>
        <section class="modal-card-body">
            <slot name="body-pre"></slot>
            {#each fields as field}
                {#if !(field.type == "hidden") && !(field.preq && data[field.preq.field] != field.preq.value)}
                    <Field {...field} bind:value={data[field.name]} {errors} on:change={field.onChange} />
                {/if}
            {/each}
            <slot name="body-post"></slot>
        </section>
        <footer class="modal-card-foot">
            <slot name="footer-pre"></slot>
            <slot name="buttons">
                {#if showDelete}
                    <span class="button is-danger is-left" on:click|preventDefault={deleteAction}>Delete</span>
                {/if}
                <span class="button" on:click|preventDefault={cancelAction}>{cancelButton}</span>
                <button class="button is-success">{saveButton}</button>
            </slot>
            <slot name="footer-post"></slot>
        </footer>
    </form>
    </div>
</div>

<style>
    /*.modal {
        z-index: 999;
    }
    */

    .modal-card-foot {
        justify-content: flex-end;
    }

    .modal-card-body {
        max-height: calc(100vh - 175px);
    }
</style>